/**
 * Paiement d'une commande.
 *
 * Le paiement est une entite distincte de la commande et de la facture, et il
 * se deroule en deux temps : le client declare, quelqu'un verifie. Seule la
 * confirmation termine la commande et emet la facture.
 *
 * En mobile money, Scan2Eat declenche l'encaissement chez le prestataire au lieu
 * de verifier une reference saisie : le convive donne un numero, la demande est
 * poussee sur son telephone, et le verdict vient du prestataire.
 *
 * Voir docs/adr/0012-paiement-verifie-avant-cloture.md et
 * docs/adr/0018-encaisser-le-mobile-money-par-paydunya.md.
 */
/** Moyens proposes au client. Les autres valeurs de PaymentMethod sont historiques. */
export const OFFERED_PAYMENT_METHODS = ['MOBILE_MONEY', 'COUNTER'];
/**
 * Etats d'un paiement.
 *
 * `DECLARED` couvre aussi l'attente de la validation sur le telephone du
 * convive : la demande est partie, il n'a pas encore tape son code. Pas de
 * quatrieme etat pour dire ce que celui-ci dit deja.
 */
export const PAYMENT_STATUSES = ['DECLARED', 'CONFIRMED', 'REJECTED'];
/** Operateurs de mobile money au Benin. */
export const MOBILE_MONEY_PROVIDERS = ['MTN', 'MOOV', 'CELTIIS'];
/**
 * Qui a tranche. `OPERATOR_API` designe le verdict rendu par le prestataire
 * d'encaissement, `MANUAL` celui d'un membre du personnel -- qui reste un repli
 * permanent, non un mode transitoire.
 */
export const PAYMENT_VERIFICATION_MODES = ['MANUAL', 'OPERATOR_API'];
/** Bac a sable ou production, par compte marchand. */
export const PAYMENT_PROVIDER_MODES = ['TEST', 'LIVE'];
/* -------------------------------------------------------------------------- */
/* Bornes                                                                      */
/* -------------------------------------------------------------------------- */
/**
 * Longueur maximale d'une reference de transaction mobile money.
 * Les operateurs beninois emettent des references courtes ; la borne protege
 * le stockage sans presumer d'un format precis, qui differe d'un operateur a
 * l'autre.
 */
export const PAYMENT_REFERENCE_MAX_LENGTH = 64;
/**
 * Bornes du numero de telephone du payeur, une fois les separateurs retires.
 *
 * Huit chiffres au Benin, jusqu'a quinze avec un indicatif international : la
 * borne haute suit l'E.164 plutot que l'usage local, parce qu'un convive
 * colle parfois son numero au format international.
 */
export const PAYER_PHONE_MIN_LENGTH = 8;
export const PAYER_PHONE_MAX_LENGTH = 15;
//# sourceMappingURL=payment.js.map